<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Resignation</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Resignation</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <a @click="setAddResignation()" class="btn add-btn"><i class="fa fa-plus"></i> Add Resignation</a>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table :headers="headers" :items="sortedResignation" sort-by="firstName" class="elevation-1">
                  <template v-slot:[`item.resignationDate`]="{ item }">
                    {{
                      item.resignationDate
                      ? new Date(item.resignationDate).toLocaleDateString()
                      : ""
                    }}
                  </template>
                  <template v-slot:[`item.noticeDate`]="{ item }">
                    {{
                      item.noticeDate
                      ? new Date(item.noticeDate).toLocaleDateString()
                      : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i
                          class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right" v-if="!item.exitInterview">
                        <a class="dropdown-item" @click="setDetailResignation(item)"><i class="fa fa-pencil-o m-r-5"></i>
                          View Detail</a>
                        <a
                          class="dropdown-item"
                          @click="setDeleteResignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                      <div class="dropdown-menu dropdown-menu-right" v-else>
                        <a
                          class="dropdown-item"
                          @click="setInviteResignation(item)"
                          v-if="item.status == 0 && item.exitInterview.interviewDate === '0001-01-01T00:00:00'"
                          ><i class="fa fa-pencil m-r-5"></i> Send Interview
                          Invitation</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0 && item.exitInterview.interviewDate !== '0001-01-01T00:00:00'"
                          @click="setEditResignation(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Add Remark</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setResignationStatus(item)"
                          v-if="item.status == 0"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                        <a class="dropdown-item" @click="setDetailResignation(item)"><i class="fa fa-pencil-o m-r-5"></i>
                          View Detail</a>
                        <a
                          class="dropdown-item"
                          @click="setDeleteResignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a @click="setDetailResignation(item)" class="avatar">
                        <img alt="" src="~@/assets/profiles/avatar-02.jpg" v-if="!item.employee.passportPhoto" />
                        <img alt="" :src="media + item.employee.passportPhoto" width="38"
                          v-if="item.employee.passportPhoto" /></a>

                      <a @click="setDetailResignation(item)">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</a>
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <div v-if="item.exitInterview">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && !item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.exitInterview.document && item.exitInterview.interviewDate === '0001-01-01T00:00:00'"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Document Uploaded
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.exitInterview.interviewDate !== '0001-01-01T00:00:00'"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-info"></i> Pending
                      Interview
                    </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1" aria-expanded="false">
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2" aria-expanded="false">
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </div>
                  <div v-else>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1" aria-expanded="false">
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2" aria-expanded="false">
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Resignation Modal -->
        <v-dialog v-model="dialogAdd" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Resignation</h5>
              <button type="button" class="close" @click="closeAdd">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitResignation()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
                      <strong>Error!</strong> {{ error }}
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="message">
                      <strong>Success!</strong> {{ message }}
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>
                  <multiselectvue class="from-control" v-model="employeeId" placeholder="Select one"
                    :custom-label="nameOfEmployee" :options="sortedEmployeeNames" :searchable="true"
                    @select="optionSelected" :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.firstName }} {{ option.lastName
                    }}</template>
                  </multiselectvue>
                </div>
                <div class="form-group">
                  <label>Resignation Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker v-model="noticeDate" calendar-class input-class bootstrap-styling
                      class="form-control datetimepicker" type="text" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Interview Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker v-model="interviewDate" calendar-class input-class bootstrap-styling
                      class="form-control datetimepicker" type="text" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Reason <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="reason" rows="4"></textarea>
                </div>
                <div class="form-group">
                  <label>Remark <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="remark" rows="4"></textarea>
                </div>
                <div class="form-group">
                  <label>Observation <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="observation" rows="4"></textarea>
                </div>
                <div class="form-group">
                  <label>Status <span class="text-danger">*</span></label>
                  <select class="select form-control" v-model="resignationStatus">
                  <option value="null">choose request status</option>
                    <option value="1">Approve</option>
                    <option value="2">Decline</option>
                  </select>
                </div>
                <div class="submit-section">
                  <button type="submit" class="btn btn-primary submit-btn"
                    :disabled="loading ? true : false">
                    {{ !loading ? "Submit" : "Please wait..." }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Resignation Modal -->

        <!-- Send Interview Invitation Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Send Interview Invitation</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label>Interview Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker v-model="interviewDate" calendar-class input-class bootstrap-styling
                      class="form-control datetimepicker" type="text" />
                  </div>
                </div>
                <div class="submit-section">
                  <button @click.prevent="onSubmit" data-dismiss="modal" class="btn btn-primary submit-btn"
                    :disabled="submitted">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Send Interview Invitation Modal -->
        <!-- Query Details Modal -->

        <v-dialog v-model="dialogDetail" max-width="725px">
          <div class="modal-content mt-5">
            <div class="modal-header">
              <h5 class="modal-title">Detail</h5>
              <button type="button" class="close" @click="closeDetail">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>
                  <input class="form-control" readonly :value="resignation.employee.firstName +
                    ' ' +
                    resignation.employee.lastName
                    " />
                </div>
                <div class="form-group">
                  <label>Notice Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <input class="form-control" readonly :value="new Date(resignation.noticeDate).toLocaleDateString()
                      " />
                  </div>
                </div>
                <div class="form-group">
                  <label>Employee Reason <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="resignation.reason" rows="4" readonly></textarea>
                </div>
                <div class="form-group" v-if="resignation.exitInterview">
                  <label>Interview Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <input class="form-control" readonly :value="new Date(
                      resignation.exitInterview.interviewDate
                    ).toLocaleDateString()
                      " />
                  </div>
                </div>
                <div class="form-group" v-if="resignation.exitInterview">
                  <label>HR Observations<span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="resignation.exitInterview.observation" rows="4"
                    readonly></textarea>
                </div>
                <div class="form-group" v-if="resignation.exitInterview">
                  <label>HR Remark<span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="resignation.exitInterview.remark" rows="4" readonly></textarea>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Query Details Modal -->
         <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button type="button" class="close" @click="closeStatus">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Resignation Approve</h3>
                  <p>Are you sure want to approve for this resignation?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
        <!-- Add Observation Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Observation and Remark</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <p class="text-danger text-center" v-if="resignationStatus != null">
                {{ errorMessage }}
              </p>
              <form @submit.prevent="updateEmployeeResignation">
                <div class="form-group" v-if="resignation.exitInterview">
                  <label>Observation <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="resignation.exitInterview.observation" rows="4"></textarea>
                </div>

                <div class="form-group" v-if="resignation.exitInterview">
                  <label>Remark <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="resignation.exitInterview.remark" rows="4"></textarea>
                </div>

                <div class="form-group" v-if="resignation.exitInterview">
                  <label>Status <span class="text-danger">*</span></label>
                  <select class="select form-control" v-model="resignation.status">
                    <option value="1">Approve</option>
                    <option value="2">Decline</option>
                  </select>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Observation Modal -->

        <!-- Delete Resignation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Resignation</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a @click.prevent="deleteEmployeeResignation" class="btn btn-primary continue-btn"
                      data-dismiss="modal">Delete</a>
                  </div>
                  <div class="col-6">
                    <a href="javascript:void(0);" data-dismiss="modal" @click="closeDelete"
                      class="btn btn-primary cancel-btn">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import {
  required,
  sameAs
} from "vuelidate/lib/validators";
import {
  employeeService
} from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import {
  authenticationService
} from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogDetail: false,
      media: "data:image/jpeg;base64,",
      headers: [{
        text: "Resigning Employee",
        align: "start",
        value: "profile"
      },

      {
        text: "Reason",
        value: "reason"
      },
      {
        text: "Notice Date",
        value: "noticeDate"
      },
      {
        text: "Resignation Date",
        value: "resignationDate"
      },
      {
        text: "Status",
        value: "stat"
      },
      {
        text: "",
        value: "actions",
        sortable: false
      }
      ],
      name: "",
      employeeId: "",
      reason: "",
      noticeDate: "",
      interviewDate: "",
      resignationDate: "",
      resignation: {
        employee: {},
        exitInterview: {}
      },
      resignations: [],
      employee: [],
      loading: false,
      error: "",
      employees: [],
      submitted: false,
      file: null,
		  fileName: null,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
    };
  },

  validations: {
    name: {
      required
    },
    reason: {
      required
    },
    noticeDate: {
      required
    },
    resignationDate: {
      required
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  computed: {
    sortedResignation: function () {
      function compare(a, b) {
        if (new Date(a.noticeDate).getTime() < new Date(b.noticeDate).getTime())
          return 1;
        if (new Date(a.noticeDate).getTime() > new Date(b.noticeDate).getTime())
          return -1;
        return 0;
      }

      return this.resignations ?
        this.resignations.sort(compare) :
        this.resignations;
    },

    sortedEmployeeNames: function () {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees ? this.employees.sort(compare) : this.employees;
    }
  },
  methods: {
    // getEmployees(id) {
    //   employeeService.getEmployees(id).then(
    //     (model) => {
    //       console.log(model);
    //       this.employees = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   );
    // },

      // multiselect for employee list
      nameOfEmployee({
      firstName,
      lastName
    }) {
      return `${firstName} ${lastName}`;
    },

    optionSelected(option, id) {
      console.log('employees:', option.id, this.employeeId.id);
      this.designationName = option.designation;
      console.log('employeeSel', option)
      this.empId = option.id
      console.log(typeof this.empId);
      this.rankName = option.rank;
      this.employeeName = option.id;
      this.employeeCode = option.employeeCode;
    },

    onFilePicked(event) {
      const files = event.target.files
      this.fileName = files[0].name
      this.file = files[0];
    },

    changeFile(){
      this.file = null
      this.fileName = ''
    },
    changeLeaveStatus(status) {
      this.submitted = true;
      this.resignation.status = parseInt(status)
      this.loading = true;
      employeeService.updateEmployeeResignation(this.resignation.id, this.resignation).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployeeResignations(this.company.id)
          .then(
            o => { this.resignations = o,
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeResignations() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeResignations(unit.id).then(
        (model) => {
          // console.log(model)
          this.resignations = model;
        },
        (error) => {
          error = error;
        }
      );
    },

    clearModel() {
      this.interviewDate= ""
    },

    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeAdd() {
      this.dialogAdd = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    closeDetail() {
      this.dialogDetail = false;
    },
    setAddResignation() {
      this.dialogAdd = true;
    },
    setEditResignation(model) {
      this.resignation = model;
      this.dialogEdit = true;
    },
    setDetailResignation(model) {
      this.resignation = model;
      this.dialogDetail = true;
    },
    setInviteResignation(model) {
      this.resignation = model;
      this.dialog = true;
    },
    setDeleteResignation(model) {
      this.resignation = model;
      this.dialogDelete = true;
    },
    submitResignation() {
      this.submitted = true;
      this.loading = true;
      console.log('employeeId', this.employeeId)
      var data = {
        noticeDate: this.noticeDate,
        resignationDate: new Date(),
        reason: this.reason,
        employeeId: this.empId,
        status: parseInt(this.resignationStatus),
        exitInterview: {
          interviewDate: this.interviewDate,
          observation: this.observation,
          remark: this.remark
        }
      }
      employeeService.addEmployeeResignation(data).then(res => {
        console.log('Add Res', res)
        this.message = 'Resignation added successfully'
        var unit = JSON.parse(localStorage.getItem("companyUnit"));
        employeeService.getEmployeeResignations(unit.id).then(
          model => {
            // console.log(model)
            this.resignations = model;
            this.closeAdd()
            this.clearModel()
            this.loading = false
          },
          error => {
            error = error;
          }
        );
      }, err => {
        console.log('Add Error:', err)
        this.error = err
        this.loading = false
      })
    },

    onSubmit() {
      this.submitted = true;

      this.resignation.exitInterview.interviewDate = this.interviewDate
      this.loading = true;
      employeeService
        .addExitInterview(
          this.resignation.exitInterview.id,
          this.resignation.exitInterview
        )
        .then(
          (id) => {
            employeeService.getEmployeeResignations(this.company.id).then((w) => {
              this.resignations = w;
              this.close();
              this.loading = false;
            });
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    async updateEmployeeResignation () {
        this.submitted = true;

        this.loading = true;
        // console.log(this.resignation)
        this.resignation.status = parseInt(this.resignation.status)
        await employeeService.UpdateExitInterview(this.resignation.exitInterview.id, this.resignation.exitInterview)
        employeeService.updateEmployeeResignation(this.resignation.id, this.resignation)
                .then(id => {
                  employeeService.getEmployeeResignations(this.company.id)
                    .then(
                      o => {this.resignations = o,
                      // console.log(o),
                      this.closeEdit()}
                    )
          },
                error => {
                    this.error = error;
                    this.loading = false;
                }
            );

    },

    deleteEmployeeResignation() {
      const id = this.resignation.id;
      // console.log(this.resignation)
      employeeService.removeEmployeeResignation(id).then(id => {
        var unit = JSON.parse(localStorage.getItem("companyUnit"));
        employeeService.getEmployeeResignations(unit.id).then(
          model => {
            this.resignations = model;
            // console.log(model)
            this.closeDelete();
          },
          error => {
            error = error;
          }
        );
      });
    }
  },

  mounted() {
    this.getEmployees();
    this.getEmployeeResignations();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeResignations(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "resignation"
};
</script>



// WEBPACK FOOTER //
// src/components/resignation/resignation.vue